import { create } from "domain"
import { api } from "../api/api"
import { ApiResponse } from "../models/base/ApiResponse"
import { WorkingHourSettingsDTO } from "../models/workingHours/workingHour.response"
import { CreateWorkingHourListDTO, UpdateWorkingHourListDTO } from "../models/workingHours/workingHour.request"



export const workingHoursService = {

    async getByLocalId(localId: string): Promise<ApiResponse<WorkingHourSettingsDTO[]>> {
        const { data } = await api.get<ApiResponse<WorkingHourSettingsDTO[]>>(`/locals/${localId}/workingHours`)
        return data
    },

    async createList(localId: string, workingHours: CreateWorkingHourListDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/locals/${localId}/workingHours`, workingHours)
        return data
    },

    async updateList(localId: string, workingHours: UpdateWorkingHourListDTO): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/workingHours`, workingHours)
        return data
    }

}